import { render, staticRenderFns } from "./PropertyQuestions.vue?vue&type=template&id=f90bede4&"
import script from "./PropertyQuestions.vue?vue&type=script&lang=js&"
export * from "./PropertyQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports